import format from 'date-fns/format';
import { LocationEnum } from '@/__generated__/graphql';
import { getGuestsQuery } from './guests';
import { locales } from '@/i18n';
import addDaysFns from 'date-fns/addDays';
import startOfToday from 'date-fns/startOfToday';

const addDays = (date, days) => {
  date.setDate(date.getDate() + days);
  return date;
};

export const clean = (object) => {
  Object.entries(object).forEach(([k, v]) => {
    if (v && typeof v === 'object') {
      clean(v);
    }
    if (
      (v && typeof v === 'object' && !Object.keys(v).length) ||
      v === null ||
      v === undefined
    ) {
      if (Array.isArray(object)) {
        object.splice(k, 1);
      } else {
        delete object[k];
      }
    }
  });
  return object;
};

export const buildListingDetailsQuery = (
  startDate,
  endDate,
  guests,
  location,
  tab,
  rooms,
  rating,
  price,
  amenities
) => {
  const esc = encodeURIComponent;

  const params = {
    locationId: location?.id || 'SE',
    startDate,
    endDate,
    ...getGuestsQuery(guests),
    tab: tab,
    ...rooms,
    rating: rating > 0 || rating === 0 ? `${rating}` : undefined,
    priceMin: price?.min ? price.min : undefined,
    priceMax: price?.max ? price.max : undefined,
    amenities: amenities?.length ? amenities : undefined,
  };

  const url = Object.keys(params)
    .filter((key) => !!params[key])
    .map((k) => esc(k) + '=' + esc(params[k]))
    .join('&');

  return url ? `?${url}` : url;
};

export const getListingDetailsVariables = (startDate, endDate) => ({
  priceStartDate: startDate
    ? startDate
    : format(addDays(new Date(), -1), 'yyyy-MM-dd'),
  priceEndDate: endDate
    ? endDate
    : format(addDays(new Date(), -1), 'yyyy-MM-dd'),
});

export const getListingLocaleSlug = (item, locale) =>
  locale === locales.sv ? item?.slug : item?.slug;

export {
  prepareBookingParams,
  parseAmenities,
  getInitialSearchState,
  buildSearchQuery,
  joinSearchQuery,
} from './booking-params';

export { getQueryFromPath } from './url';

export const hasMap = (variables) => {
  return !(
    variables?.filters?.locationType === LocationEnum.Country ||
    !variables?.filters?.availability?.startDate ||
    !variables?.filters?.availability?.endDate
  );
};

import { getInitialSearchState } from './booking-params';
import { getListingsVariables } from '@/components/listings/api_utils';
export const hasFilters = (state) => {
  const initial = getInitialSearchState({});

  return (
    !!state?.amenities?.length ||
    !!state?.price?.min ||
    !!state?.price?.max ||
    state?.rooms?.beds !== initial?.rooms?.beds ||
    state?.rooms?.bedrooms !== initial?.rooms?.bedrooms ||
    state?.rooms?.bathrooms !== initial?.rooms?.bathrooms
  );
};

export const getListingLongTermVariables = (isLongTerm, slug) => {
  const currentDate = startOfToday();
  const params = isLongTerm
    ? {
        adults: 2,
        startDate: addDaysFns(new Date(currentDate), 14),
        endDate: addDaysFns(new Date(currentDate), 14 + 30),
      }
    : {};

  const { date, guests } = getInitialSearchState({
    ...params,
    startDate: params.startDate ? format(params.startDate, 'yyyy-MM-dd') : null,
    endDate: params.endDate ? format(params.endDate, 'yyyy-MM-dd') : null,
  });
  const variables = getListingsVariables(null, guests, null, null, date);

  variables.filters.listingGroupSlug = slug;
  return { params, variables };
};
